import { entityTypeSchema, type RichTextElement } from '../data-contract/chat';

// Inline mention markup the agent embeds in plain-string fields (e.g. question
// labels): ⟦type:id|label⟧, such as ⟦role:ad63650f-…|Nanoscale Research⟧. The
// brackets are U+27E6/U+27E7 so they never collide with markdown syntax. This
// parses such a string into rich-text elements (text + mention) that the mention
// markdown pipeline can render.
const MENTION_PATTERN = /⟦([a-z_]+):([^|⟧]+)\|([^⟧]*)⟧/gu;

export const parseMentionMarkup = (text: string): readonly RichTextElement[] => {
    const elements: RichTextElement[] = [];
    let lastIndex = 0;

    for (const match of text.matchAll(MENTION_PATTERN)) {
        const [token, rawType, id, label] = match;
        const start = match.index ?? 0;
        if (token === undefined || id === undefined || label === undefined) continue;
        const type = entityTypeSchema.safeParse(rawType);
        // Unknown entity types are left untouched: the token stays part of the text.
        if (!type.success) continue;

        if (start > lastIndex) {
            elements.push({ text: text.slice(lastIndex, start), type: 'text' });
        }
        elements.push({
            entity: { id, type: type.data },
            label: label.length > 0 ? label : id,
            type: 'mention',
        });
        lastIndex = start + token.length;
    }

    if (lastIndex < text.length) {
        elements.push({ text: text.slice(lastIndex), type: 'text' });
    }
    return elements;
};
